"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Translate_exports = {};
__export(Translate_exports, {
  default: () => Translate_default
});
module.exports = __toCommonJS(Translate_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.0859 12.4961L9.36719 10.7773L9.38672 10.7578C9.95964 10.1198 10.4609 9.42969 10.8906 8.6875C11.3203 7.93229 11.6589 7.13802 11.9062 6.30469H13.918V4.9375H9.13281V3.58984H7.76562V4.9375H3V6.30469H10.6172C10.3828 6.95573 10.0833 7.59375 9.71875 8.21875C9.36719 8.83073 8.94401 9.41016 8.44922 9.95703C8.13672 9.60547 7.85026 9.24089 7.58984 8.86328C7.32943 8.47266 7.09505 8.07552 6.88672 7.67188H5.51953C5.76693 8.23177 6.0599 8.77214 6.39844 9.29297C6.73698 9.8138 7.12109 10.3086 7.55078 10.7773L4.07422 14.2148L5.05078 15.1719L8.44922 11.7734L10.5781 13.8828L11.0859 12.4961ZM14.9336 9.03906H13.5664L10.5 17.2227H11.8672L12.6289 15.1719H15.8711L16.6328 17.2227H18L14.9336 9.03906ZM13.1367 13.8047L14.25 10.8555L15.3633 13.8047H13.1367Z",
      fill: "currentColor"
    }
  )
);
const SvgTranslate = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Translate_default = SvgTranslate;
